import {Injectable} from "@angular/core";
import {Observable, of, Subject} from "rxjs";
import {OrdersApiService} from "src/app/api/orders-api.service";
import {ArticleType, OrderItem} from "src/app/model/order/order";
import {MessageService} from "../message/message.service";

@Injectable()
export class CartService {
  cartItems$: Subject<OrderItem[]> = new Subject<OrderItem[]>();
  cartItems: OrderItem[] = [];

  constructor(private ordersApi: OrdersApiService, private messages: MessageService) {
    this.cartItems$.subscribe((value) => {
      this.cartItems = value;
    });
  }

  public fetchCartItems() {
    this.ordersApi.getCartItems().subscribe(data => {
      this.cartItems = data;
      this.cartItems.forEach(cartItem => {
        cartItem.isNew = false;
        cartItem.isUpdate = false;
      });
      this.cartItems$.next(this.cartItems);
    });
  }

  public getCartItems(): Observable<OrderItem[]> {
    return of(this.cartItems);
  }

  public markLensesAsSaved() {
    for (let index = 0; index < this.cartItems.length; index++) {
      this.cartItems[index].isNew = false;
    }
    this.cartItems$.next(this.cartItems);
  }

  public addCartCareAccessoriesItem(cartItem: OrderItem) {

    let index = this.cartItems.findIndex(item => item.article.id === cartItem.article.id);
    if (index > -1) {
      this.cartItems[index].count += cartItem.count;
      this.cartItems[index].isUpdate = true;
      this.cartItems[index].isNew = false;
    } else {
      cartItem.isNew = true;
      cartItem.isUpdate = false;
      this.cartItems.push(cartItem);
    }
    this.cartItems$.next(this.cartItems);
    if (cartItem.article.type === ArticleType.CARE) {
      this.messages.info("newOrder.messages.careAdded")
    } else if (cartItem.article.type === ArticleType.ACCESSORY) {
      this.messages.info("newOrder.messages.accessoryAdded")
    }
  }

  public addCartLensesItem(cartItem: OrderItem, warning?: boolean) {
    this.cartItems.push(cartItem);
    this.cartItems$.next(this.cartItems);

    if (warning) {
      this.messages.orange("newOrder.finalLens.desireDateEqualize");
    } else {
      this.messages.info("newOrder.messages.lensAdded");
    }
  }

  public updateCartLensesItem(cartItem: OrderItem, index: number, warning?: boolean) {
    if (cartItem.orderId) {
      cartItem.isUpdate = true;
      cartItem.isNew = false;
    }
    let intermediateCartItem = this.cartItems.filter(cartItem => cartItem.article.type === ArticleType.LENS)[index];
    let indexCartItem = this.cartItems.findIndex(cartItem => JSON.stringify(cartItem) === JSON.stringify(intermediateCartItem));
    this.cartItems[indexCartItem] = cartItem;
    this.cartItems$.next(this.cartItems);

    if (warning) {
      this.messages.orange("newOrder.finalLens.desireDateEqualize");
    } else {
      this.messages.info("newOrder.messages.lensAdded");
    }
  }

  public deleteCartItems(ids: number[]) {
    this.ordersApi.deleteCartItems(ids).subscribe(response => {
      if (response.success) {
        let orderItems = this.cartItems.filter(cartItem => cartItem.isNew === false);
        this.ordersApi.cleanCart({orderItems: orderItems});
        this.messages.info("home.orders.orderItemDeleted");
      }
    });
  }

  public deleteCartItem(cartItem: OrderItem) {
    let index = this.cartItems.findIndex(item => item.article.id === cartItem.article.id);
    if (cartItem.isNew) {
      this.cartItems.splice(index, 1);
      this.cartItems$.next(this.cartItems);
      this.messages.info("home.orders.orderItemDeleted");
    } else {
      this.ordersApi.deleteCartItem(this.cartItems[index].orderItemId).subscribe(response => {
        if (response.success) {
          this.cartItems.splice(index, 1);
          this.cartItems$.next(this.cartItems);
          this.messages.info("home.orders.orderItemDeleted");
        }
      })
    }
  }

  public clearCart() {
    this.cartItems = [];
    this.cartItems$.next(this.cartItems);
  }

  public solvePair(newDate: Date, commission: string) {
    let lenses: any = this.cartItems;
    lenses.filter(lens => commission == lens.commission).forEach(lens => lens.desireDate = newDate);
  }
}
